import { useCallback } from 'react'
import { useMailStore } from '../stores/mailStore'
import { useAccountStore } from '../stores/accountStore'

/**
 * Returns a `markImportant(threadId, isImportant)` callback that:
 * 1. Optimistically updates local state.
 * 2. Persists via JMAP setKeyword($important).
 */
export function useMarkImportant() {
  const { markImportant: localMark } = useMailStore()

  return useCallback((threadId: string, isImportant: boolean) => {
    localMark(threadId, isImportant)

    const client = useAccountStore.getState().getActiveClient()
    if (!client) return

    client.setThreadKeyword(threadId, '$important', isImportant).catch(() => {})
  }, [localMark])
}
